export default __webpack_public_path__ + "static/media/image18.91aa1905.png";